import { render, staticRenderFns } from "./MonacoEditor.vue?vue&type=template&id=0cf0f0c0&scoped=true&"
import script from "./MonacoEditor.vue?vue&type=script&lang=ts&"
export * from "./MonacoEditor.vue?vue&type=script&lang=ts&"
import style0 from "./MonacoEditor.vue?vue&type=style&index=0&id=0cf0f0c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf0f0c0",
  null
  
)

export default component.exports